import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { installDeploymentPreloadRecovery } from './app/deployment-preload-recovery';
import { activateTelegramMiniApp, prepareTelegramMiniApp } from './app/telegram-mini-app';
import { detectLocale } from './i18n/I18nProvider';
import { loadMessageCatalog } from './i18n/messages';
import './ui/base.css';
import './ui/application.css';
import './ui/reference.css';
import './ui/palette.css';
import './ui/theme.css';
import './ui/tokens.css';
import './ui/foundation.css';
import './ui/app-font.css';
import './ui/components.css';
import './ui/figma-components.css';
import './ui/card.css';

installDeploymentPreloadRecovery();
const telegramMiniApp = await prepareTelegramMiniApp();

const root = document.getElementById('root');
if (!root) {
  throw new Error('Application root is missing');
}

await loadMessageCatalog(detectLocale());

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);

window.requestAnimationFrame(() => activateTelegramMiniApp(telegramMiniApp));
